/**
 * Каталог труб: типовые материалы квартирной разводки. Первый элемент — труба
 * по умолчанию, с неё начинает инструмент. Цвет здесь условный, для панели каталога:
 * на плане труба красится по среде — холодная синим, горячая красным.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import type { CatalogSection } from "../../types";
import type { PipeCatalogItem } from "./types";

export const pipeSection: CatalogSection<PipeCatalogItem> = {
	kind: LayerKind.Pipes,
	label: "Труба",
	canChangeDimensions: false,
	subGroups: ["Полипропилен", "Сшитый полиэтилен", "Металлопластик"],
	items: [
		{
			id: "pipe-ppr-20",
			subGroup: "Полипропилен",
			name: "PP-R 20",
			description: "Полипропилен с армированием, пайка. Стандарт для разводки по санузлу.",
			color: "#94a3b8",
			diameter: 20,
			hotCapable: true,
		},
		{
			id: "pipe-ppr-25",
			subGroup: "Полипропилен",
			name: "PP-R 25",
			description: "Полипропилен 25 мм: магистраль от стояка до коллектора.",
			color: "#94a3b8",
			diameter: 25,
			hotCapable: true,
		},
		{
			id: "pipe-pex-16",
			subGroup: "Сшитый полиэтилен",
			name: "PEX 16",
			description:
				"Сшитый полиэтилен на аксиальных фитингах, гнётся — для коллекторной разводки в стяжке.",
			color: "#f59e0b",
			diameter: 16,
			hotCapable: true,
		},
		{
			id: "pipe-mp-16",
			subGroup: "Металлопластик",
			name: "Металлопластик 16",
			description: "Металлопластик на пресс-фитингах: гнётся руками, недорогой.",
			color: "#e2e8f0",
			diameter: 16,
			hotCapable: true,
		},
	],
};
